export default __webpack_public_path__ + "img/4b41c4a8c6fa615823fb22916d05c63a.svg";